import React from 'react'
import { withRouter } from 'react-router-dom'
import { Layout, Menu, Avatar, Button, Dropdown } from 'antd'
import authService from '../services/authentication.service'

import './PublicLayout.css'

const { Header, Content, Footer } = Layout

const PublicLayout = props => {
  const currentPath = window.location.pathname
  const user = authService.getAuthenticatedUser()

  const handleLogout = async () => {
    await authService.joinUsLogOut()
    window.location.href = '/joinus/login'
  }

  const menu = (
    <Menu>
      <Menu.Item>
        <Button type="link" onClick={handleLogout}>
          Log out
        </Button>
      </Menu.Item>
    </Menu>
  )

  return currentPath.endsWith('/joinus') ? (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        className="header"
        style={{ background: '#252d3b', borderBottom: '1px solid #1890ff' }}
      >
        <div style={{ float: 'right', paddingRight: '10px' }}>
          <Dropdown overlay={menu} placement="bottomCenter" trigger={['click']}>
            <Button
              style={{ background: '#272a39', borderColor: '#272a39' }}
              size="large"
            >
              <span style={{ color: '#fff', padding: '5px' }}>
                {user.firstName} {user.lastName}{' '}
              </span>
              <Avatar size="default" icon="user" />
            </Button>
          </Dropdown>
        </div>
        <div
          className="header__logo"
          style={{ height: '50px', marginTop: '10px' }}
        />
      </Header>
      <Content
        style={{
          margin: '0 16px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {props.children}
      </Content>
    </Layout>
  ) : (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        className="header"
        style={{ background: '#252d3b', borderBottom: '1px solid #1890ff' }}
      >
          <div
              className="header__logo"
              style={{ height: '50px', marginTop: '10px' }}
          />
      </Header>
      <Content
       className="shared-layout-content"
      >
        {props.children}
      </Content>
        <Footer style={{ textAlign: 'center', height: '10px' }}></Footer>
    </Layout>
  )
}

export default withRouter(PublicLayout)
